<template>
  <div class="reports-table-container">
    <div class="desktop-view">
      <AppTable :data="reports">
        <ElTableColumn prop="project_name" label="Project name" width="300" class-name="name-column" />
        <ElTableColumn prop="project_location" label="Site Location" width="300" />
        <ElTableColumn prop="date" label="Date" width="180">
          <template #default="{ row }">
            {{ formatHumanFriendlyDate(row.date) }}
          </template>
        </ElTableColumn>
        <ElTableColumn prop="status" label="Status" width="120">
          <template #default="{ row }">
            <AppChip :variant="statusVariant(row.status)">
              {{ statusText(row.status) }}
            </AppChip>
          </template>
        </ElTableColumn>
        <ElTableColumn v-if="isAdmin()" prop="contact_opt_in" label="Contact me" width="120">
          <template #default="{ row }">
            <AppIcon color="green" size="32" type="check" v-if="row.contact_opt_in" />
            <AppIcon color="grey" size="32" type="x" v-else />
          </template>
        </ElTableColumn>
        <ElTableColumn prop="actions" label="Actions" width="120">
          <template #default="{ row }">
            <router-link
              v-if="row.id"
              :to="{
                name: 'report-details',
                params: { id: row.id },
                state: { backRoute },
              }"
              class="router-button"
            >
              <AppIcon color="white" type="show" size="16" class="mr-8px" />
              View
            </router-link>
          </template>
        </ElTableColumn>
      </AppTable>
    </div>

    <div class="mobile-view">
      <ReportCard
        v-for="report in reports"
        :key="report.id"
        :report="report"
        :back-route="backRoute"
      />
    </div>
  </div>
</template>

<script setup>
import { ElTableColumn } from "element-plus";
import { AppChip, AppIcon, AppTable } from "@/components/ui";

import { isAdmin } from "@/utilities/token";
import { formatHumanFriendlyDate } from "@/utilities/date";
import ReportCard from "./ReportCard.vue";

defineProps({
  reports: {
    type: Array,
    required: true,
  },
  backRoute: {
    type: Object,
    required: true,
  },
});

const statusVariant = (status) => {
  return status === "completed" || status === true ? "success" : "warning";
};

const statusText = (status) => {
  return status === "completed" ? "Completed" : "Draft";
};
</script>

<style lang="scss" scoped>
.mobile-view {
  display: none;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
}

.desktop-view {
  @media (max-width: 768px) {
    display: none;
  }
}
</style>
